import {
  Companion_getInstance241hfcdeiz4z5 as Companion_getInstance,
  UnlockProjectRequestsb9zq5gbmeux as UnlockProjectRequest,
  LockInfo3qyh26jodrlpf as LockInfo,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AccessInfoj60d6hx1qs8r as AccessInfo } from './supportModels.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(UnlockProjectRequest_project_getInstance());
}
function prepareUnlockProjectRequestFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [UnlockProjectRequest__id_getInstance(), UnlockProjectRequest_project_getInstance(), UnlockProjectRequest_lock_getInstance(), UnlockProjectRequest_submitted_getInstance(), UnlockProjectRequest_submittedByClient_getInstance(), UnlockProjectRequest_message_getInstance(), UnlockProjectRequest_attachments_getInstance(), UnlockProjectRequest_accepted_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function UnlockProjectRequest_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function UnlockProjectRequest_project$_get_name_$ref_xmn4dd() {
  return (p0) => p0.k20();
}
function UnlockProjectRequest_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UnlockProjectRequest_project$_get_serializer_$ref_avjem0() {
  return (p0) => p0.j2j();
}
function UnlockProjectRequest_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function UnlockProjectRequest_project$_get_annotations_$ref_y3jrg4() {
  return (p0) => p0.bz();
}
var UnlockProjectRequest_projectClass;
function UnlockProjectRequest_project() {
  if (UnlockProjectRequest_projectClass === VOID) {
    class $ {
      constructor() {
        UnlockProjectRequest_project_instance = this;
        var tmp = this;
        tmp.h86_1 = lazy(UnlockProjectRequest_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i86_1 = lazy(UnlockProjectRequest_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j86_1 = lazy(UnlockProjectRequest_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.h86_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UnlockProjectRequest_project$_get_name_$ref_xmn4dd(), null);
        return tmp0.f2();
      }
      k86(receiver) {
        return receiver.m86_1;
      }
      m2j(receiver) {
        return this.k86(receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE());
      }
      t86(receiver, value) {
        return receiver.u86(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE();
        return this.t86(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i86_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UnlockProjectRequest_project$_get_serializer_$ref_avjem0(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j86_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UnlockProjectRequest_project$_get_annotations_$ref_y3jrg4(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'UnlockProjectRequest_project', VOID, VOID, [SerializableProperty()]);
    UnlockProjectRequest_projectClass = $;
  }
  return UnlockProjectRequest_projectClass;
}
var UnlockProjectRequest_project_instance;
function UnlockProjectRequest_project_getInstance() {
  if (UnlockProjectRequest_project_instance === VOID)
    new (UnlockProjectRequest_project())();
  return UnlockProjectRequest_project_instance;
}
function UnlockProjectRequest__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function UnlockProjectRequest__id$_get_name_$ref_sj8iea() {
  return (p0) => p0.k20();
}
function UnlockProjectRequest__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UnlockProjectRequest__id$_get_serializer_$ref_6v2sw9() {
  return (p0) => p0.j2j();
}
function UnlockProjectRequest__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function UnlockProjectRequest__id$_get_annotations_$ref_frrscz() {
  return (p0) => p0.bz();
}
var UnlockProjectRequest__idClass;
function UnlockProjectRequest__id() {
  if (UnlockProjectRequest__idClass === VOID) {
    class $ {
      constructor() {
        UnlockProjectRequest__id_instance = this;
        var tmp = this;
        tmp.v86_1 = lazy(UnlockProjectRequest__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w86_1 = lazy(UnlockProjectRequest__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x86_1 = lazy(UnlockProjectRequest__id$annotations$delegate$lambda);
        this.y86_1 = Companion_getInstance_0().m2p();
        this.z86_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.v86_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UnlockProjectRequest__id$_get_name_$ref_sj8iea(), null);
        return tmp0.f2();
      }
      k86(receiver) {
        return receiver.l86_1;
      }
      m2j(receiver) {
        return this.k86(receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE());
      }
      t86(receiver, value) {
        return receiver.u86(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE();
        return this.t86(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w86_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UnlockProjectRequest__id$_get_serializer_$ref_6v2sw9(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x86_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UnlockProjectRequest__id$_get_annotations_$ref_frrscz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'UnlockProjectRequest__id', VOID, VOID, [SerializableProperty()]);
    UnlockProjectRequest__idClass = $;
  }
  return UnlockProjectRequest__idClass;
}
var UnlockProjectRequest__id_instance;
function UnlockProjectRequest__id_getInstance() {
  if (UnlockProjectRequest__id_instance === VOID)
    new (UnlockProjectRequest__id())();
  return UnlockProjectRequest__id_instance;
}
function UnlockProjectRequest_lock$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function UnlockProjectRequest_lock$_get_name_$ref_ihlg7x() {
  return (p0) => p0.k20();
}
function UnlockProjectRequest_lock$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UnlockProjectRequest_lock$_get_serializer_$ref_f1y0xo() {
  return (p0) => p0.j2j();
}
function UnlockProjectRequest_lock$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function UnlockProjectRequest_lock$_get_annotations_$ref_odxemg() {
  return (p0) => p0.bz();
}
var UnlockProjectRequest_lockClass;
function UnlockProjectRequest_lock() {
  if (UnlockProjectRequest_lockClass === VOID) {
    class $ {
      constructor() {
        UnlockProjectRequest_lock_instance = this;
        var tmp = this;
        tmp.a87_1 = lazy(UnlockProjectRequest_lock$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b87_1 = lazy(UnlockProjectRequest_lock$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c87_1 = lazy(UnlockProjectRequest_lock$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.a87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UnlockProjectRequest_lock$_get_name_$ref_ihlg7x(), null);
        return tmp0.f2();
      }
      k86(receiver) {
        return receiver.n86_1;
      }
      m2j(receiver) {
        return this.k86(receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE());
      }
      d87(receiver, value) {
        return receiver.u86(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE();
        return this.d87(tmp, value instanceof LockInfo() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UnlockProjectRequest_lock$_get_serializer_$ref_f1y0xo(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UnlockProjectRequest_lock$_get_annotations_$ref_odxemg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'UnlockProjectRequest_lock', VOID, VOID, [SerializableProperty()]);
    UnlockProjectRequest_lockClass = $;
  }
  return UnlockProjectRequest_lockClass;
}
var UnlockProjectRequest_lock_instance;
function UnlockProjectRequest_lock_getInstance() {
  if (UnlockProjectRequest_lock_instance === VOID)
    new (UnlockProjectRequest_lock())();
  return UnlockProjectRequest_lock_instance;
}
function UnlockProjectRequest_submitted$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function UnlockProjectRequest_submitted$_get_name_$ref_9dgal() {
  return (p0) => p0.k20();
}
function UnlockProjectRequest_submitted$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UnlockProjectRequest_submitted$_get_serializer_$ref_ustsmi() {
  return (p0) => p0.j2j();
}
function UnlockProjectRequest_submitted$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function UnlockProjectRequest_submitted$_get_annotations_$ref_ni81ri() {
  return (p0) => p0.bz();
}
var UnlockProjectRequest_submittedClass;
function UnlockProjectRequest_submitted() {
  if (UnlockProjectRequest_submittedClass === VOID) {
    class $ {
      constructor() {
        UnlockProjectRequest_submitted_instance = this;
        var tmp = this;
        tmp.e87_1 = lazy(UnlockProjectRequest_submitted$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f87_1 = lazy(UnlockProjectRequest_submitted$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g87_1 = lazy(UnlockProjectRequest_submitted$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.e87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UnlockProjectRequest_submitted$_get_name_$ref_9dgal(), null);
        return tmp0.f2();
      }
      k86(receiver) {
        return receiver.o86_1;
      }
      m2j(receiver) {
        return this.k86(receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE());
      }
      h87(receiver, value) {
        return receiver.u86(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE();
        return this.h87(tmp, value instanceof AccessInfo() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UnlockProjectRequest_submitted$_get_serializer_$ref_ustsmi(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UnlockProjectRequest_submitted$_get_annotations_$ref_ni81ri(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'UnlockProjectRequest_submitted', VOID, VOID, [SerializableProperty()]);
    UnlockProjectRequest_submittedClass = $;
  }
  return UnlockProjectRequest_submittedClass;
}
var UnlockProjectRequest_submitted_instance;
function UnlockProjectRequest_submitted_getInstance() {
  if (UnlockProjectRequest_submitted_instance === VOID)
    new (UnlockProjectRequest_submitted())();
  return UnlockProjectRequest_submitted_instance;
}
function UnlockProjectRequest_submittedByClient$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function UnlockProjectRequest_submittedByClient$_get_name_$ref_4v3qe3() {
  return (p0) => p0.k20();
}
function UnlockProjectRequest_submittedByClient$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UnlockProjectRequest_submittedByClient$_get_serializer_$ref_3p6t58() {
  return (p0) => p0.j2j();
}
function UnlockProjectRequest_submittedByClient$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function UnlockProjectRequest_submittedByClient$_get_annotations_$ref_b9nxxs() {
  return (p0) => p0.bz();
}
var UnlockProjectRequest_submittedByClientClass;
function UnlockProjectRequest_submittedByClient() {
  if (UnlockProjectRequest_submittedByClientClass === VOID) {
    class $ {
      constructor() {
        UnlockProjectRequest_submittedByClient_instance = this;
        var tmp = this;
        tmp.i87_1 = lazy(UnlockProjectRequest_submittedByClient$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j87_1 = lazy(UnlockProjectRequest_submittedByClient$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k87_1 = lazy(UnlockProjectRequest_submittedByClient$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.i87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UnlockProjectRequest_submittedByClient$_get_name_$ref_4v3qe3(), null);
        return tmp0.f2();
      }
      k86(receiver) {
        return receiver.p86_1;
      }
      m2j(receiver) {
        return this.k86(receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE());
      }
      l87(receiver, value) {
        return receiver.u86(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE();
        return this.l87(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.j87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UnlockProjectRequest_submittedByClient$_get_serializer_$ref_3p6t58(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UnlockProjectRequest_submittedByClient$_get_annotations_$ref_b9nxxs(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'UnlockProjectRequest_submittedByClient', VOID, VOID, [SerializableProperty()]);
    UnlockProjectRequest_submittedByClientClass = $;
  }
  return UnlockProjectRequest_submittedByClientClass;
}
var UnlockProjectRequest_submittedByClient_instance;
function UnlockProjectRequest_submittedByClient_getInstance() {
  if (UnlockProjectRequest_submittedByClient_instance === VOID)
    new (UnlockProjectRequest_submittedByClient())();
  return UnlockProjectRequest_submittedByClient_instance;
}
function UnlockProjectRequest_message$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function UnlockProjectRequest_message$_get_name_$ref_9dq92p() {
  return (p0) => p0.k20();
}
function UnlockProjectRequest_message$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UnlockProjectRequest_message$_get_serializer_$ref_uz5bbe() {
  return (p0) => p0.j2j();
}
function UnlockProjectRequest_message$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function UnlockProjectRequest_message$_get_annotations_$ref_kreym2() {
  return (p0) => p0.bz();
}
var UnlockProjectRequest_messageClass;
function UnlockProjectRequest_message() {
  if (UnlockProjectRequest_messageClass === VOID) {
    class $ {
      constructor() {
        UnlockProjectRequest_message_instance = this;
        var tmp = this;
        tmp.m87_1 = lazy(UnlockProjectRequest_message$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n87_1 = lazy(UnlockProjectRequest_message$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o87_1 = lazy(UnlockProjectRequest_message$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.m87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UnlockProjectRequest_message$_get_name_$ref_9dq92p(), null);
        return tmp0.f2();
      }
      k86(receiver) {
        return receiver.q86_1;
      }
      m2j(receiver) {
        return this.k86(receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE());
      }
      p87(receiver, value) {
        return receiver.u86(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE();
        return this.p87(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UnlockProjectRequest_message$_get_serializer_$ref_uz5bbe(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UnlockProjectRequest_message$_get_annotations_$ref_kreym2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'UnlockProjectRequest_message', VOID, VOID, [SerializableProperty()]);
    UnlockProjectRequest_messageClass = $;
  }
  return UnlockProjectRequest_messageClass;
}
var UnlockProjectRequest_message_instance;
function UnlockProjectRequest_message_getInstance() {
  if (UnlockProjectRequest_message_instance === VOID)
    new (UnlockProjectRequest_message())();
  return UnlockProjectRequest_message_instance;
}
function UnlockProjectRequest_attachments$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function UnlockProjectRequest_attachments$_get_name_$ref_g5b57s() {
  return (p0) => p0.k20();
}
function UnlockProjectRequest_attachments$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UnlockProjectRequest_attachments$_get_serializer_$ref_7upl35() {
  return (p0) => p0.j2j();
}
function UnlockProjectRequest_attachments$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function UnlockProjectRequest_attachments$_get_annotations_$ref_e8zx9f() {
  return (p0) => p0.bz();
}
var UnlockProjectRequest_attachmentsClass;
function UnlockProjectRequest_attachments() {
  if (UnlockProjectRequest_attachmentsClass === VOID) {
    class $ {
      constructor() {
        UnlockProjectRequest_attachments_instance = this;
        var tmp = this;
        tmp.q87_1 = lazy(UnlockProjectRequest_attachments$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r87_1 = lazy(UnlockProjectRequest_attachments$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s87_1 = lazy(UnlockProjectRequest_attachments$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.q87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UnlockProjectRequest_attachments$_get_name_$ref_g5b57s(), null);
        return tmp0.f2();
      }
      k86(receiver) {
        return receiver.r86_1;
      }
      m2j(receiver) {
        return this.k86(receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE());
      }
      t87(receiver, value) {
        return receiver.u86(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE();
        return this.t87(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UnlockProjectRequest_attachments$_get_serializer_$ref_7upl35(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UnlockProjectRequest_attachments$_get_annotations_$ref_e8zx9f(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'UnlockProjectRequest_attachments', VOID, VOID, [SerializableProperty()]);
    UnlockProjectRequest_attachmentsClass = $;
  }
  return UnlockProjectRequest_attachmentsClass;
}
var UnlockProjectRequest_attachments_instance;
function UnlockProjectRequest_attachments_getInstance() {
  if (UnlockProjectRequest_attachments_instance === VOID)
    new (UnlockProjectRequest_attachments())();
  return UnlockProjectRequest_attachments_instance;
}
function UnlockProjectRequest_accepted$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function UnlockProjectRequest_accepted$_get_name_$ref_uq9m3r() {
  return (p0) => p0.k20();
}
function UnlockProjectRequest_accepted$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function UnlockProjectRequest_accepted$_get_serializer_$ref_h1svnk() {
  return (p0) => p0.j2j();
}
function UnlockProjectRequest_accepted$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function UnlockProjectRequest_accepted$_get_annotations_$ref_nlc404() {
  return (p0) => p0.bz();
}
var UnlockProjectRequest_acceptedClass;
function UnlockProjectRequest_accepted() {
  if (UnlockProjectRequest_acceptedClass === VOID) {
    class $ {
      constructor() {
        UnlockProjectRequest_accepted_instance = this;
        var tmp = this;
        tmp.u87_1 = lazy(UnlockProjectRequest_accepted$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v87_1 = lazy(UnlockProjectRequest_accepted$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w87_1 = lazy(UnlockProjectRequest_accepted$annotations$delegate$lambda);
        this.x87_1 = null;
        this.y87_1 = 'null';
      }
      k20() {
        var tmp0 = this.u87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UnlockProjectRequest_accepted$_get_name_$ref_uq9m3r(), null);
        return tmp0.f2();
      }
      k86(receiver) {
        return receiver.s86_1;
      }
      m2j(receiver) {
        return this.k86(receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE());
      }
      z87(receiver, value) {
        return receiver.u86(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof UnlockProjectRequest() ? receiver : THROW_CCE();
        return this.z87(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UnlockProjectRequest_accepted$_get_serializer_$ref_h1svnk(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w87_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UnlockProjectRequest_accepted$_get_annotations_$ref_nlc404(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'UnlockProjectRequest_accepted', VOID, VOID, [SerializableProperty()]);
    UnlockProjectRequest_acceptedClass = $;
  }
  return UnlockProjectRequest_acceptedClass;
}
var UnlockProjectRequest_accepted_instance;
function UnlockProjectRequest_accepted_getInstance() {
  if (UnlockProjectRequest_accepted_instance === VOID)
    new (UnlockProjectRequest_accepted())();
  return UnlockProjectRequest_accepted_instance;
}
//region block: exports
export {
  prepareUnlockProjectRequestFields as prepareUnlockProjectRequestFields39v0wbswlqc4j,
  get_project as get_project24cljftix7ci2,
};
//endregion

//# sourceMappingURL=UnlockProjectRequestFields.mjs.map
